import usePostApiToken from "../../ApiTemplate/PostApiWithToken";
import apiConfig from "../../../Config/apiConfig";

const useGetQuizzes = () => {
  const postApiCall = usePostApiToken();

  // Make getTopics function async to wait for the API response
  const getQuizzes = async (body, apiData) => {
    try {
      // Await the result of the API call
      const data = await postApiCall(apiConfig.endpoints.getQuizzes, body);
      // console.log("QUIZ DATA: Inside api template", data);
      console.log("QUIZ DATA: Inside api template", data);

      // For Inside Classroom Tour Guide.
      let tourStatus = data.data.class_tour_status === 1;
      sessionStorage.setItem("class_tour_status", tourStatus);

      // Perform any operations you need with the fetched data
      apiData(data);

      // Optional: Debugging/logging
    } catch (error) {
      console.error("Error fetching data:", error);
      // Optionally, handle the error by passing it to apiData or other logic
    }
  };

  return getQuizzes;
};

export default useGetQuizzes;
